import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { CategoryProvider } from "@/context/CategoryContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { NeuralBackground } from "@/components/NeuralBackground";
import { LoginSplash } from "@/components/LoginSplash";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MIS from "@/pages/MIS";
import Banks from "@/pages/Banks";
import Payables from "@/pages/Payables";
import Receivables from "@/pages/Receivables";
import Investments from "@/pages/Investments";
import Expenses from "@/pages/Expenses";
import Income from "@/pages/Income";
import Transfers from "@/pages/Transfers";
import Sweeps from "@/pages/Sweeps";
import Vendors from "@/pages/Vendors";
import Debtors from "@/pages/Debtors";
import FixedDeposits from "@/pages/FixedDeposits";
import FixedAssets from "@/pages/FixedAssets";
import BackupRestore from "@/pages/BackupRestore";
import Reconciliation from "@/pages/Reconciliation";
import Cashflow from "@/pages/Cashflow";
import DayClose from "@/pages/DayClose";
import Journal from "@/pages/Journal";
import ExceptionInbox from "@/pages/ExceptionInbox";
import Sop from "@/pages/Sop";
import InvoiceInbox from "@/pages/InvoiceInbox";
import Payroll from "@/pages/Payroll";
import CostCenters from "@/pages/CostCenters";
import InvoiceReconciliation from "@/pages/InvoiceReconciliation";

function SplashHost() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (user && typeof user === "object" && !sessionStorage.getItem("ethara_splash_shown")) {
      sessionStorage.setItem("ethara_splash_shown", "1");
      setOpen(true);
      const t = setTimeout(() => setOpen(false), 4500);
      return () => clearTimeout(t);
    }
  }, [user]);
  return <LoginSplash open={open} onDismiss={() => setOpen(false)} />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <CurrencyProvider>
          <CategoryProvider>
          <NeuralBackground />
          <SplashHost />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="banks" element={<Banks />} />
                <Route path="inbox" element={<ExceptionInbox />} />
                <Route path="sop" element={<Sop />} />
                <Route path="recon" element={<Reconciliation />} />
                <Route path="cashflow" element={<Cashflow />} />
                <Route path="day-close" element={<DayClose />} />
                <Route path="journal" element={<Journal />} />
                <Route path="income" element={<Income />} />
                <Route path="transfers" element={<Transfers />} />
                <Route path="sweeps" element={<Sweeps />} />
                <Route path="payables" element={<Payables />} />
                <Route path="vendors" element={<Vendors />} />
                <Route path="invoice-inbox" element={<InvoiceInbox />} />
                <Route path="invoice-recon" element={<InvoiceReconciliation />} />
                <Route path="payroll" element={<Payroll />} />
                <Route path="cost-centers" element={<CostCenters />} />
                <Route path="debtors" element={<Debtors />} />
                <Route path="backup" element={<BackupRestore />} />
                <Route path="receivables" element={<Receivables />} />
                <Route path="mis" element={<MIS />} />
                <Route path="investments" element={<Investments />} />
                <Route path="fixed-deposits" element={<FixedDeposits />} />
                <Route path="fixed-assets" element={<FixedAssets />} />
                <Route path="expenses" element={<Expenses />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
          </CategoryProvider>
        </CurrencyProvider>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
